export default __webpack_public_path__ + "static/media/logo.b0cda9c7.svg";